var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "notification_add_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 6",
    fill: "none",
    d: "M0 0h20v20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 5"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 7",
    d: "M13.333 11.667v2.5H6.666V8.334a3.332 3.332 0 013.333-3.333 3.241 3.241 0 011.9.6l1.192-1.192a4.892 4.892 0 00-1.842-.908v-.584a1.25 1.25 0 00-2.5 0V3.5a4.989 4.989 0 00-3.75 4.833v5.834H3.333v1.667h13.333v-1.667H15v-2.5zM10 18.334a1.672 1.672 0 001.666-1.667H8.333A1.672 1.672 0 0010 18.334zM20 6.667h-2.5v-2.5h-1.667v2.5h-2.5v1.667h2.5v2.5H17.5v-2.5H20z",
    fill: "#666"
  }))));
}

export default SvgNotificationPlusIcon;